<template>
  <v-container>
    <FormRow 
      v-if="supportsCodec"
      label="Video Codec"
      :input-payload="codec"
      :dropdown="true"
      :options="codecMap"
      @parseNewVAl="parseEncoding($event, 'codec', 'Recording / Video Codec')"
    />
    <v-row>
      <v-col cols="12">
        <span>Include the following labels in video recordings:</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col 
        v-for="(label, index) in labels"
        :key="index"
        cols="12"
        class="align-vertical no-padding"
      >
        <v-checkbox
          v-model="selected"
          :label="labelMap(label.name[0])"
          :value="label.name[0]"
          @change="parseNewVal(label.name[0], labelMap(label.name[0]))"
        />
      </v-col>
    </v-row>  
  </v-container>
</template>

<script>

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

import { checkIfVersionIsAboveLimit } from '@/utils';


import FormRow from '../components/FormRow.vue';

export default {
  name: 'Recording',
  components: {
    FormRow
  },
  mixins:  [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    },
    firmwareVersion: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selected: [],
      codec: '',
      codecMap: [
        {
          xml: 'h264',
          label: 'H264'
        },
        {
          xml: 'h265',
          label: 'H265'
        }
      ]
    }
  },
  computed: {
    labels() {
      return this.config.device_config.video[0].encoding[0].labels[0].label;
    },
    selectedCodec() {
      return this.config.device_config.video[0].encoding[0].encoderType ? this.config.device_config.video[0].encoding[0].encoderType[0] : 'h264';
    },
    supportsCodec() {
      const minimumVersion = '01.01.39';
      if(this.deviceModel == 'CAMERAMATICS_JI7A-SD-4G') {
        return true
      }
      if (this.deviceModel == 'CAMERAMATICS_JH8_NT-HD-4G' || this.deviceModel == 'CAMERAMATICS_JH4_NT-HD-4G') {
        return checkIfVersionIsAboveLimit(this.firmwareVersion, minimumVersion);
      }
      return false;
    }
  },
  mounted() {
    this.parseLabelState();
    if (this.supportsCodec) {
      this.codec = this.selectedCodec;
    }
  },
  methods: {
    labelMap(label) {
      let map = {
        ioState: 'IO Pin State',
        gps: 'GPS Coordinates',
        speed: 'Speed',
        channelName: 'Channel Name',
        speedLimit: 'Speed Limit'
      };

      return map[label];
    },
    parseLabelState() {
      this.labels.forEach(label => {
        if (label.show[0] === 'true') {
          this.selected.push(label.name[0]);
        }
      });
    },
    parseEncoding(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.codecMap]),
        key: this.configPropMapper(id),
        label: label
      }
      this.$emit('settingsUpdated', payload, this.codecMap);
    },
    parseNewVal(id, label) {
      let payload = {
        newValue: this.returnMappedVal(this.checkIfInArray(id), []),
        key: this.configPropMapper(id),
        label: label,
        context: {
          newValue: id,
          key: this.configPropMapper(`${id}Label`),
          label: 'name'
        }
      }

      this.$emit('settingsUpdated', payload);
    },
    checkIfInArray(val) {
      return this.selected.includes(val);
    },
    configPropMapper(key) {
      let map = {
        'ioState': 'device_config.video[0].encoding[0].labels[0].label[0].show[0]',
        'ioStateLabel': 'device_config.video[0].encoding[0].labels[0].label[0].name[0]',
        'gps': 'device_config.video[0].encoding[0].labels[0].label[1].show[0]',
        'gpsLabel': 'device_config.video[0].encoding[0].labels[0].label[1].name[0]',
        'speed': 'device_config.video[0].encoding[0].labels[0].label[2].show[0]',
        'speedLabel': 'device_config.video[0].encoding[0].labels[0].label[2].name[0]',
        'channelName': 'device_config.video[0].encoding[0].labels[0].label[3].show[0]',
        'channelNameLabel': 'device_config.video[0].encoding[0].labels[0].label[3].name[0]',
        'speedLimit': 'device_config.video[0].encoding[0].labels[0].label[4].show[0]',
        'speedLimitLabel': 'device_config.video[0].encoding[0].labels[0].label[4].name[0]',
        'codec': 'device_config.video[0].encoding[0].encoderType[0]'
      }

      return map[key];
    }
  }
}
</script>

<style lang="scss" scoped>
  .align-vertical {
    justify-content: left;
    align-items: center;
    display: flex;
  }
  .no-padding {
    padding: 0 .5em !important;
    margin: 0 !important;
  }
  .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
</style>